import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InboxState {
    data: unknown[];
    loading: boolean;
    error: string | null;
}

const initialState: InboxState = {
    data: [],
    loading: false,
    error: null
};

export const inboxSlice = createSlice({
    name: 'inbox',
    initialState,
    reducers: {
        setMessages: (state, action: PayloadAction<unknown[]>) => {
            state.data = action.payload
        },
        setMessagesLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        },
        setMessagesError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload
        }
    }
});

export const { setMessages, setMessagesLoading, setMessagesError } = inboxSlice.actions;

export default inboxSlice.reducer;

